import { configureStore } from '@reduxjs/toolkit';
import userSlice from './features/userSlice';
import allocationSlice from './features/allocationSlice';
import auctionSlice from './features/auctionSlice';
import biddersSlice from './features/biddersSlice';
import bidSlice from './features/bidSlice';
import websocketSlice from './features/websocketSlice';
import websocketSubscriptionSlice from './features/websocketSubscriptionSlice';
import liveAuctionDetailsSlice from './features/liveAuctionDetailsSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import propertiesSlice from './features/propertiesSlice';
import { propertiesApi } from './services/properties';
import leaveRequestSlice from './features/leaveRequestSlice';
import minVisitsSlice from './features/minVisitsSlice';
import receiptManagmentSlice from './features/receiptManagmentSlice';
import targetSlice from './features/targetSlice';
import teleAllocationSlice from './features/teleAllocationSlice';
import teleAgentSlice from './features/teleAgentSlice';
import loanRequestSlice from './features/loanSlice';
import trailRequestSlice from './features/trailSlice';
import monthlyProgressSlice from './features/monthlyProgressSlice';
import visitSlice from './features/visitSlice';
import IncentivesGamificationsSlice from './features/IncentivesGamificationsSlice';
import calenderSlice from './features/calenderSlice';
import accountsSlice from './features/accountsSlice';

export const store = configureStore({
  reducer: {
    bidders: biddersSlice.reducer,
    websocket: websocketSlice.reducer,
    websocketSubscriptions: websocketSubscriptionSlice.reducer,
    auction: auctionSlice.reducer,
    bid: bidSlice.reducer,
    allocations: allocationSlice.reducer,
    user: userSlice.reducer,
    liveAuctionDetails: liveAuctionDetailsSlice.reducer,
    properties: propertiesSlice.reducer,
    minVisits: minVisitsSlice.reducer,
    receipt: receiptManagmentSlice.reducer,
    target: targetSlice.reducer,
    teleAllocation: teleAllocationSlice.reducer,
    teleAgent: teleAgentSlice.reducer,
    accountSlice: accountsSlice.reducer,
    [propertiesApi.reducerPath]: propertiesApi.reducer,
    leaveRequestAction: leaveRequestSlice.reducer,
    loanRequestAction: loanRequestSlice.reducer,
    trailRequestAction: trailRequestSlice.reducer,
    monthlyProgressAction: monthlyProgressSlice.reducer,
    visit: visitSlice.reducer,
    incentiesGamifications: IncentivesGamificationsSlice.reducer,
    calender: calenderSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      propertiesApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
